var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTarget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3066 16.9475L47.5676 16.176L46.7979 9.43703L54.4986 1.73633L56.3757 7.36785L62.0073 9.24503L54.3066 16.9475Z",
    stroke: "#0086FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2988 36.4441L47.5672 16.1758",
    stroke: "#0086FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9657 30.2041C45.3795 36.2727 44.1315 43.4574 39.2217 48.369C32.637 54.9536 21.9602 54.9536 15.3755 48.369C8.79084 41.7843 8.79084 31.1075 15.3755 24.5228C20.2853 19.613 27.4717 18.365 33.5404 20.7788",
    stroke: "#0086FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4367 13.7314C28.9942 9.09935 17.2649 10.7091 9.4133 18.5607C-0.464588 28.4385 -0.464588 44.452 9.4133 54.3281C19.2912 64.206 35.3046 64.206 45.1825 54.3281C53.0341 46.4766 54.6438 34.7472 50.0117 25.3048",
    stroke: "#0086FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4542 28.0955C25.929 27.7475 23.2787 28.543 21.3381 30.4853C18.0449 33.7785 18.0449 39.1152 21.3381 42.4084C24.6313 45.6998 29.9679 45.7016 33.2611 42.4084C35.2017 40.4678 35.9972 37.8157 35.6509 35.2905",
    stroke: "#0086FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.c8120008b3487c90a5229b322453192e.svg";
export { ForwardRef as ReactComponent };